<template>
  <div
    class="index fcc"
    id="app1"
    :style="{ backgroundImage: 'url(' + bgImgUrl + ')' }"
  >
    <img class="img2" src="/static/imgs/img1.png" v-if="maxInfo2.length == 0" />
    <img
      class="img2s"
      src="/static/imgs/img1.png"
      v-if="maxInfo2.length == 0"
    />
    <div class="tit">{{ name }}</div>
    <div class="openBot cc" @click="rollName">进入抽奖</div>
    <!-- <div class="openBots cc" v-else>奖项已抽完</div> -->
    <div class="code fcc">
      <img
        class="img1"
        :src="
          'https://web.justhouse.cn/BigInterface/Index/code&code=' +
          this.$route.query.code
        "
      />
      <div class="ps">扫码查询抽奖详情</div>
    </div>
    <div class="bot" v-if="maxInfo2.length == 0">
      <img class="img3" src="/static/imgs/img2.png" />
    </div>
    <div class="frcs gud">
      此服务由小程序「微购会」提供技术支持
      <div class="frc botRi">
        <img
          class="img4"
          v-if="rightShow == 1"
          @click="hideRight"
          src="/static/imgs/img3.png"
        />
        <img
          class="img4"
          v-else
          @click="hideRight"
          src="/static/imgs/img4.png"
        />
        <div class="set1 cc" v-if="rightShow == 0" @click="hideRight">
          展开菜单
        </div>
        <div class="frc" v-if="rightShow == 1">
          <!-- <div class="set1 cc" @click="goBack">返回首页</div> -->
          <div class="set1 cc">更换背景</div>
          <div class="setImg">
            <upload-img ref="uploadimg" @transmit="getMessage"></upload-img>
          </div>
          <div class="set1 cc" @click="openAudio">
            {{ isplaying == true ? "关闭音效" : "开启音效" }}
          </div>
          <div class="set1 cc" @click="setlun">选择轮次</div>
          <el-button
            class="set1 cc"
            style="
              background: none;
              color: #fcc876;
              border: 1px solid #fcc876;
              font-size: 16px;
              margin-left: 10px;
              display: flex;
            "
            v-if="!fullscreen"
            @click="fullScreen()"
            >全屏显示</el-button
          >
          <el-button
            class="set1 cc"
            style="
              background: none;
              color: #fcc876;
              border: 1px solid #fcc876;
              font-size: 16px;
              margin-left: 10px;
              display: flex;
            "
            v-else
            @click="exitFullscreen()"
            >退出全屏</el-button
          >
        </div>
      </div>
    </div>
    <!-- 查看弹窗 -->
    <div
      :class="show == false ? 'zhe dis_none' : 'zhe'"
      @click="zheclick"
    ></div>
    <div :class="show == false ? 'zheBox2 dis_none' : 'zheBox2'">
      <div class="ztit">选择轮次</div>
      <div class="frcs zbox" v-for="(item, index) in awardList">
        <div class="frc">
          <img :src="item.img" />
          <div class="fc">
            <div
              style="text-align: left; margin-bottom: 6px; font-weight: bold"
            >
              {{ item.award_name }}
            </div>
            <div style="text-align: left">第{{ item.chinese_number }}轮</div>
          </div>
        </div>
        <div
          class="zxh"
          @click="onNum"
          :data-ty="item.open_status"
          :data-id="item.id"
        >
          {{ item.open_status == 1 ? "展示名单" : "进入抽奖" }}
        </div>
      </div>
    </div>
    <!-- 音频播放 -->
    <audio ref="audio" style="opacity: 0">
      <source
        src="/static/audio/背景音乐.MP3"
        loop
        autoplay
        type="audio/mp3"
        v-if="isplaying == true"
      />
    </audio>
    <!-- 音频播放 结束-->
    <!--  -->
    <div :class="show2 == false ? 'zheBox3 cc dis_none' : 'zheBox3 cc'">
      奖项已抽完！ 点击下方 ‘选择轮次’ 按钮，可查看中奖名单 !
    </div>
  </div>
</template>
  <script>
import uploadImg from "../components/uploadImg.vue";
export default {
  components: { uploadImg },
  data() {
    return {
      shows: "",
      show: false,
      show2: false,
      name: "",
      fullscreen: false,
      rightShow: 1,
      isplaying: true,
      maxInfo2: "",
      bgImgUrl:
        " background-image: linear-gradient(to bottom, #d93326, #ff5f52)",
    };
  },
  methods: {
    getMessage(id) {
      this.obtainType();
    },
    obtainType() {
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
      };
      this.$get(this.$axios.defaults.orURL + "/index/drawIndex", param).then(
        (res) => {
          this.maxInfo2 = res.data.web_img;
          this.$refs.audio.play();
          this.bgmXun = setInterval(() => {
            this.$refs.audio.play();
          }, 20000);
          this.name = res.data.name;
          if (res.data.web_img.length > 0) {
            this.bgImgUrl = res.data.web_img;
          }
          if (res.data.end_status == 1) {
            this.shows = false;
          } else {
            this.shows = true;
          }
        }
      );
    },
    // 隐藏右下角功能按钮
    hideRight() {
      if (this.rightShow == 0) {
        this.rightShow = 1;
      } else {
        this.rightShow = 0;
      }
    },

    // 背景音乐
    openAudio() {
      if (this.isplaying == false) {
        this.isplaying = true;
        this.$refs.audio.play();
        this.bgmXun = setInterval(() => {
          this.$refs.audio.play();
        }, 20000);
      } else {
        clearInterval(this.bgmXun);
        this.isplaying = false;
        this.$refs.audio.pause();
      }
    },

    // 返回首页
    goBack() {
      this.$router.go(-1);
    },

    // 全屏功能
    fullScreen() {
      var full = document.body || document.documentElement;
      this.fullscreenFn(full);
      this.fullscreen = true;
    },
    exitFullscreen() {
      // 退出全屏
      if (document.exitFullscreen) document.exitFullscreen();
      else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
      else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      this.fullscreen = false;
    },
    fullscreenFn(element) {
      // 全屏
      if (element.requestFullscreen) element.requestFullscreen();
      else if (element.mozRequestFullScreen) element.mozRequestFullScreen();
      else if (element.webkitRequestFullscreen)
        element.webkitRequestFullscreen();
      else if (element.msRequestFullscreen) element.msRequestFullscreen();
    },

    rollName() {
      clearInterval(this.psp);
      // 检获取开奖id
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
      };
      this.$get(
        this.$axios.defaults.orURL + "/index/getOpenDrawId",
        param
      ).then((res) => {
        console.log(res.data.id);
        if (res.data.id == 0) {
          this.show2 = true;
          this.psp = setInterval(() => {
            this.show2 = false;
          }, 2000);
        } else {
          this.$router.push(
            "/rollName?code=" + this.$route.query.code + "&sy=" + this.isplaying
          );
        }
      });
    },

    // 奖品列表 弹窗
    setlun() {
      var param = {
        session_3rd: localStorage.getItem("session_3rd"),
      };
      this.$get(this.$axios.defaults.orURL + "/index/awardList", param).then(
        (res) => {
          if (res.code == 1) {
            console.log(res);
            console.log(res.data);
            this.awardList = res.data;
            this.show = true;
          }
        }
      );
    },
    // 点击选择轮次
    onNum(e) {
      this.id = e.target.dataset.id;
      this.$router.push(
        "/rollName?id=" +
          this.id +
          "&code=" +
          this.$route.query.code +
          "&sy=" +
          this.isplaying
      );
      // this.drawIndex();
      // if (ty == 0) {
      //   this.show = false;
      //   this.state = 1;
      // } else {
      //   this.show = false;
      //   this.state = 4;
      // }
    },
    zheclick() {
      this.show = false;
    },
  },
  created() {
    this.obtainType();
  },
  beforeDestroy() {},
};
</script>
  <style>
body {
  margin: 0;
  padding: 0;
}

.setImg {
  width: 90px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  margin-left: -90px;
  opacity: 0;
  background-color: #feb9b4;
}

.messageIndex {
  font-size: 50px;
  z-index: 99999 !important;
}
.dis_none {
  display: none;
}
.index .img4 {
  width: 16px;
  height: 18px;
  /* position: fixed;
  top: 100px;
  left: 80px; */
}
.set1 {
  width: 90px;
  height: 40px;
  border-radius: 4px;
  margin-left: 10px;
  color: #fcc876;
  cursor: pointer;
  border: 1px solid #fcc876;
}

.index .gud {
  width: 90%;
  position: fixed;
  bottom: 40px;
  left: 0;
  color: #feb9b4;
  margin-left: 5%;
}

.index .code {
  width: 300px;
  height: 350px;
  border-radius: 10px;
  position: fixed;
  bottom: 100px;
  right: 70px;
  background-color: #fff7e3;
}

.index .openBot {
  width: 300px;
  height: 120px;
  color: #d56926;
  font-size: 50px;
  border-radius: 8px;
  position: fixed;
  top: 40vh;
  z-index: 3;
  cursor: pointer;
  /* right: 70px; */
  background-color: #fdc976;
}

.openBots {
  width: 300px;
  height: 120px;
  color: #fff;
  font-size: 50px;
  position: fixed;
  bottom: 330px;
}

.index {
  width: 100%;
  min-height: 100vh;
  color: #fff;
  margin: 0;
  padding-top: 160px;
  box-sizing: border-box;
  background-size: cover;
  background-image: linear-gradient(to bottom, #d93326, #ff5f52);
}

.index .img2 {
  width: 80px;
  height: 80px;
  position: fixed;
  top: 100px;
  left: 80px;
}

.index .img2s {
  width: 80px;
  height: 80px;
  position: fixed;
  bottom: 200px;
  right: 100px;
}

.index .img3 {
  width: 100%;
  height: 400px;
}

.frc {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.fcc {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.frcs {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.index .tit {
  font-size: 60px;
  font-weight: bold;
  color: #fdc976;
}

.index .img1 {
  width: 250px;
  height: 250px;
  margin: 22px 0 20px;
  border-radius: 50%;
  /* background-color: #C6C6C6; */
}

.index .ps {
  font-size: 20px;
  /* margin-top: 25px; */
  color: #d56926;
}

.index .bot {
  position: absolute;
  bottom: 0px;
  width: 100%;
  font-size: 20px;
  margin-top: 50px;
  /* padding-left: 120px; */
  box-sizing: border-box;
}

/* .index .bot img {
    width: 350px;
    margin: -140px 0px 0;
  } */

/* 选择轮次 */

.zxh {
  border-bottom: 1px solid #d56926;
}

.zbox {
  width: 100%;
  height: 85px;
  padding: 0 20px;
  box-sizing: border-box;
  color: #d56926;
  border-top: 1px solid #fdc976;
}
.zhe {
  width: 100%;
  height: 100%;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 4;
  background-color: #000;
}

.zheBox2 {
  width: 350px;
  max-height: 70vh;
  position: fixed;
  top: 15vh;
  z-index: 5;
  border-radius: 10px;
  padding-top: 20px;
  overflow-y: auto;
  background-color: #fff7e3;
}

.zheBox3 {
  width: 450px;
  height: 5vh;
  position: fixed;
  top: 10vh;
  z-index: 5;
  color: #eb9008;
  border-radius: 10px;
  padding: 10px;
  overflow-y: auto;
  background-color: #fff7e3;
}

.zheBox2 img {
  width: 50px;
  height: 50px;
  margin-right: 20px;
}

.dis_none {
  display: none;
}

.ztit {
  font-size: 18px;
  color: #d56926;
  width: 100%;
  padding-bottom: 20px;
}
</style>
  


// WEBPACK FOOTER //
// src/pages/raffle.vue